import { useState, FormEvent } from 'react';

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // Check honeypot
    const form = e.currentTarget;
    const honeypot = form.querySelector('[name="phone_alt"]') as HTMLInputElement;
    if (honeypot && honeypot.value.trim() !== '') {
      setStatus('success');
      setEmail('');
      return;
    }

    if (!email || !email.includes('@')) {
      setErrorMsg('Please enter a valid email address.');
      setStatus('error');
      return;
    }

    setStatus('submitting');
    setErrorMsg('');

    try {
      const formData = new FormData(form);
      const response = await fetch('', {
        method: 'POST',
        body: formData,
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || 'Something went wrong. Please try again.';
        setErrorMsg(serverMsg);
        setStatus('error');
      }
    } catch {
      setErrorMsg('Network error. Please try again.');
      setStatus('error');
    }
  };

  return (
    <section className="relative overflow-hidden min-h-[300px] md:min-h-[350px] flex items-center justify-center">
      {/* Video background - exact from original */}
      <video
        autoPlay
        muted
        loop
        playsInline
        className="absolute inset-0 w-full h-full object-cover"
        poster="https://static.wixstatic.com/media/11062b_7c19cc2b1af0412e80c41bff7938eeb8f000.jpg/v1/fill/w_1280,h_720,al_c,q_85/11062b_7c19cc2b1af0412e80c41bff7938eeb8f000.jpg"
      >
        <source
          src="https://video.wixstatic.com/video/11062b_7c19cc2b1af0412e80c41bff7938eeb8/1080p/mp4/file.mp4"
          type="video/mp4"
        />
      </video>
      <div className="absolute inset-0" style={{ backgroundColor: 'rgba(42,74,124,0.55)' }} />

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-8 py-12 md:py-16 text-center">
        <h2 className="text-[10px] md:text-xs text-white tracking-[0.35em] uppercase mb-4 md:mb-6 font-medium">
          JOIN OUR MAILING LIST
        </h2>

        {status === 'success' ? (
          <p className="text-sm text-white/90">Thanks for submitting!</p>
        ) : (
          <form
            data-readdy-form
            id="newsletter-form"
            onSubmit={handleSubmit}
            className="max-w-lg mx-auto"
          >
            {/* Honeypot */}
            <input
              type="text"
              name="phone_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="honeypot-field"
            />

            <div className="flex flex-col sm:flex-row gap-3">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email here*"
                required
                maxLength={250}
                className="flex-1 px-4 py-3 text-sm bg-white/90 border-0 text-foreground-900 placeholder:text-foreground-500 focus:outline-none focus:ring-2 focus:ring-primary-400"
              />
              <button
                type="submit"
                disabled={status === 'submitting'}
                className="px-6 py-3 text-[11px] font-semibold tracking-[0.2em] uppercase text-white bg-primary-600 hover:bg-primary-500 transition-colors whitespace-nowrap disabled:opacity-60"
              >
                {status === 'submitting' ? 'Subscribing...' : 'Subscribe Now'}
              </button>
            </div>

            {status === 'error' && errorMsg && (
              <p className="text-xs text-red-300 mt-2">{errorMsg}</p>
            )}
          </form>
        )}
      </div>
    </section>
  );
}